import styled from "styled-components";
import { Routes, Route } from "react-router-dom";
import { public_route, protected_route } from "@routes";
import { IRoute } from "@interfaces";
import { FooterModule, HeaderModule } from "@module";
// import { AppDispatch, logout, openToast, resetSavedCart, selectAuth, useAppSelector } from "@redux";
// import { AppDispatch} from "@redux";
// import { useDispatch } from "react-redux";
// import { DURATION_TIME } from "@constants

interface IAppModuleLayout {
    children?: string | JSX.Element | JSX.Element[];
    onBack?: () => void;
}

export const AppModuleLayout = (props: IAppModuleLayout) => {
    const { children } = props;

    return (
        <AppLayoutWrapper>
            <HeaderModule />
            {!!children && children}
            <FooterModule />
        </AppLayoutWrapper>
    );
};

/**
 * @deprecated Use `Routes/ProtectedRoute.tsx` instead
 */
export const AppLayout = () => {
    return (
        <Container>
            <Routes>
                {protected_route.map((route: IRoute, key) => (
                    <Route key={key} path={route.path} element={<route.element />} />
                ))}
            </Routes>
        </Container>
    );
};

/**
 * @deprecated Use `Routes/PublicRoute.tsx` instead
 */
export const NormalAppLayout = () => {
    return (
        <Container>
            <Routes>
                {public_route.map((route: IRoute, key) => (
                    <Route key={key} path={route.path} element={<route.element />} />
                ))}
            </Routes>
        </Container>
    );
};

const Container = styled.div`
    height: 100%;
`;

const AppLayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: ${(props) => props.theme.colors.gray_6};
`;
